module.exports = __webpack_public_path__ + "img/no-data.70d2b30.webp";